export enum PassengerSelectionType {
  Adult,
  YoungAdult,
  Teen,
  Children,
  Infant
}